var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center font-medium"},[(_vm.icon)?_c('FontAwesomeIcon',{attrs:{"icon":['far', _vm.icon]}}):_vm._e(),_c('span',{staticClass:"ml-2 text-lg"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }